import { Component, Inject, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
  public type: string;

  @Output() onSave = new EventEmitter();

  @Output() onCancel = new EventEmitter();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      heading: string;
      okButtonText: string;
      text: string[];
      textHighlightTop?: string;
      textHighlightBottom?: string;
      id?: number;
      showCancelBtn?: boolean;
      lomyLogo?: boolean;
      rules?: any;
      cancelButtonText?: string;
    }
  ) {}
}
